import React from 'react';
import { FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-dark-base py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <FileText className="h-12 w-12 text-primary mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white">Términos y Condiciones</h1>
          <p className="mt-2 text-gray-400">Última actualización: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="prose prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Precios y Pagos</h2>
            <p className="text-gray-300">
              Todos nuestros precios incluyen IVA y están expresados en euros (€). El precio total incluye:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Precio base del servicio: €49/mes</li>
              <li>IVA (21%): €10.29</li>
              <li>Precio final: €59.29/mes</li>
            </ul>
            <p className="text-gray-300 mt-4">
              No existen costos adicionales ocultos. El cargo se realiza de forma mensual y puedes cancelar en cualquier momento.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Derecho de Desistimiento</h2>
            <p className="text-gray-300">
              De acuerdo con la normativa de la UE, tienes derecho a desistir de tu suscripción en un plazo de 14 días naturales sin necesidad de justificación. Para ejercer este derecho:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Envía un email a info@asistentetradingia.com indicando tu deseo de cancelar</li>
              <li>Utiliza nuestro formulario de contacto en la plataforma</li>
              <li>El reembolso se realizará en un plazo máximo de 14 días</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. Política de Reembolsos</h2>
            <p className="text-gray-300">
              Nuestro proceso de reembolso es simple y transparente:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Reembolso completo dentro de los primeros 14 días</li>
              <li>El reembolso se realizará por el mismo método de pago utilizado</li>
              <li>No se aplican penalizaciones por cancelación</li>
              <li>Se mantendrá el acceso al servicio hasta el final del período pagado</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Uso del Servicio</h2>
            <p className="text-gray-300">
              Nuestros servicios están diseñados para:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Análisis automatizado de gráficos de trading</li>
              <li>Gestión de diario de trading personal</li>
              <li>Programa de embajadores</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Cuentas de Usuario</h2>
            <p className="text-gray-300">
              Al crear una cuenta en nuestra plataforma:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Eres responsable de mantener la seguridad de tu cuenta</li>
              <li>Debes proporcionar información precisa y actualizada</li>
              <li>No debes compartir tus credenciales de acceso</li>
              <li>Debes notificarnos inmediatamente de cualquier brecha de seguridad</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">6. Limitación de Responsabilidad</h2>
            <p className="text-gray-300">
              Asistente Trading IA proporciona herramientas de analisis, pero:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>No garantizamos la precisión de los análisis</li>
              <li>No somos responsables de pérdidas financieras</li>
              <li>Los resultados pasados no garantizan resultados futuros</li>
              <li>El trading conlleva riesgos significativos</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">7. Naturaleza del Servicio y Regulacion Financiera</h2>
            <p className="text-gray-300">
              AsistenteTrading IA es una herramienta automatizada de analisis tecnico de estructura de mercado basada en metodologia ICT/SMC. El servicio tiene caracter exclusivamente educativo e informativo.
            </p>
            <p className="text-gray-300 mt-4">
              Este servicio NO constituye asesoramiento financiero personalizado ni recomendacion de inversion segun la Ley 6/2023 de los Mercados de Valores y de los Servicios de Inversion ni segun la Directiva MiFID II.
            </p>
            <p className="text-gray-300 mt-4">
              El analisis generado no tiene en cuenta la situacion financiera individual, perfil de riesgo, objetivos de inversion ni circunstancias personales de ningun usuario.
            </p>
            <p className="text-gray-300 mt-4">
              Operar en mercados de futuros y derivados financieros implica un riesgo significativo de perdida que puede superar el capital depositado. El usuario es el unico responsable de sus decisiones de inversion.
            </p>
            <p className="text-gray-300 mt-4">
              Este servicio no requiere autorizacion de la CNMV al no constituir actividad de asesoramiento financiero personalizado ni gestion de carteras.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">8. Programa de Embajadores</h2>
            <p className="text-gray-300">
              Los terminos especificos del programa de embajadores incluyen:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Comisiones basadas en el nivel (Trader/Trader Pro)</li>
              <li>Pago de comisiones mensual</li>
              <li>Prohibición de spam o prácticas engañosas</li>
              <li>Derecho a modificar o terminar el programa</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">9. Contacto</h2>
            <p className="text-gray-300">
              Para cualquier consulta sobre estos términos, contáctanos en:{' '}
              <a href="mailto:info@asistentetradingia.com" className="text-primary hover:text-primary-hover">
                info@asistentetradingia.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;